import React, { useEffect, useState } from 'react';
import {
  makeStyles,
  Theme,
  createStyles,
  Paper,
  Grid,
  Typography,
  Snackbar,
  useTheme,
} from '@material-ui/core';
import { useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../components/Loading';
import Alert from '@material-ui/lab/Alert';
import { getUserDetails } from '../../store/actions/users';
import { UserState } from '../../store/reducers/user';
import MaterialTable from 'material-table';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
    },
    margin: {
      marginLeft: 'auto',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    dialogFormActionContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
      display: 'flex',
      justifyContent: 'flex-end',
    },
  })
);

interface RootState {
  user: UserState;
}

const UserDetails: React.FC = () => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const theme = useTheme();

  const match = useRouteMatch<{ id: string }>('/user/:id');
  const uid = match?.params.id;

  const user = useSelector((state: RootState) => state.user);

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchUserDetails = async (companyId: string) => {
      try {
        setIsLoading(true);
        setError(null);
        await dispatch(getUserDetails(companyId));
      } catch (error) {
        setError(error.message);
      }
      setIsLoading(false);
    };

    fetchUserDetails(uid!!);
  }, [dispatch, uid]);

  const getPageSize = (): number => {
    if (user.userStations.length < 5) {
      return 5;
    } else if (user.userStations.length < 10) {
      return 10;
    } else if (user.userStations.length < 15) {
      return 15;
    } else {
      return 20;
    }
  };

  return (
    <>
      <Paper className={classes.paper}>
        <Grid container item xs={12}>
          <Grid item xs={12}>
            <Typography variant="h6" component="h6">
              User Information
            </Typography>
            <Typography variant="body1" component="p">
              Name: {user.userDetails?.name}
            </Typography>
            <Typography variant="body1" component="p">
              IC No: {user.userDetails?.icNumber}
            </Typography>
            <Typography variant="body1" component="p">
              Email: {user.userDetails?.email}
            </Typography>
            <Typography variant="body1" component="p">
              Health Status: {user.userDetails?.healthStatus}
            </Typography>
            <Typography variant="body1" component="p">
              Address: {user.userDetails?.address}
            </Typography>
            <Typography variant="body1" component="p">
              Postcode: {user.userDetails?.postcode}
            </Typography>
            <Typography variant="body1" component="p">
              State: {user.userDetails?.state}
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      <MaterialTable
        style={{ marginTop: theme.spacing(2) }}
        key={user.userStations.length}
        options={{
          search: false,
          pageSize: getPageSize(),
          pageSizeOptions: [],
        }}
        columns={[
          { title: 'Station Name', field: 'name' },
          { title: 'Address', field: 'address' },
          { title: 'Postcode', field: 'postcode' },
          { title: 'State', field: 'state' },
          { title: 'Check In Time', field: 'timestamp' },
        ]}
        data={user.userStations.map((station) => {
          return {
            name: station.stationName,
            address: station.address,
            postcode: station.postcode,
            state: station.state,
            id: station.stationId,
            timestamp: station.timestamp.toString(),
          };
        })}
        title="User's Routes"
      />

      <Loading isLoading={isLoading} />

      <Snackbar
        open={error !== null}
        autoHideDuration={3000}
        onClose={() => setError(null)}
      >
        <Alert onClose={() => setError(null)} severity="error">
          {error}
        </Alert>
      </Snackbar>
    </>
  );
};

export default UserDetails;
